import React, { lazy } from 'react';

const CleanVehicleTaxCredit = lazy(
  () =>
    import(
      /* webpackChunkName: "carvana-purchase-ev-credit" */ '|/app/purchase/cart/steps/clean-vehicle-tax-credit'
    )
);

export const CleanVehicleTaxCreditRoute = () => {
  return <CleanVehicleTaxCredit />;
};
